<div class="keyword-editor">
  <label class="wk-field-label" for="keywordEditorData"
    >{{ 'APP.KEYWORDS_DEFINITION.KEYWORD' | translate }}
  </label>
  <wk-ckeditor
    [config]="keywordPlugins"
    [(ngModel)]="keywordEditorData"
    [editor]="wkKeywordEditor"
    (ready)="onReady()"
    (editorChange)="onChange()"
    #keywordEditor
  >
  </wk-ckeditor>
</div>
